import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79faa3d8"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Lista de Sugestões ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SafeArea = _resolveComponent("SafeArea")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_Produto = _resolveComponent("Produto")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_FooterMenu = _resolveComponent("FooterMenu")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_SafeArea, {
        onOnBack: _cache[0] || (_cache[0] = ($event: any) => (_ctx.voltar())),
        data: {'cart': false}
      }),
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_row, { class: "ion-align-items-center" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "end",
                                icon: _ctx.icon_pesquisa
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.produtosProcurar,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.produtosProcurar) = $event)),
                            placeholder: "Pesquise o item que deseja",
                            onIonInput: _cache[2] || (_cache[2] = ($event: any) => (_ctx.autoComplete())),
                            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.autoComplete())),
                            onKeyup: _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.showProdutos(_ctx.produtosProcurar)), ["enter"])),
                            onInput: _cache[5] || (_cache[5] = ($event: any) => (_ctx.produtosProcurar=$event.target.value)),
                            name: "endereco",
                            type: "endereco",
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.autoCompleteProdutos.length > 0)
                ? (_openBlock(), _createBlock(_component_ion_list, { key: 0 }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.autoCompleteProdutos, (produto, index) => {
                        return (_openBlock(), _createBlock(_component_ion_item, {
                          key: index,
                          onClick: ($event: any) => (_ctx.showProdutos(produto))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_label, null, {
                              default: _withCtx(() => [
                                _createElementVNode("p", null, _toDisplayString(produto), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      }), 128))
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row, { class: "ion-align-items-center bg_white" }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { class: "font-poppins-extra font-25" }, {
                    default: _withCtx(() => [
                      _hoisted_1
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.produtos, (produto, index) => {
                    return (_openBlock(), _createBlock(_component_ion_col, {
                      size: "6",
                      class: "produto ion-text-center",
                      key: 'c'+index
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Produto, { produto: produto }, null, 8, ["produto"])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                ]),
                _: 1
              }),
              _createVNode(_component_ion_infinite_scroll, {
                onIonInfinite: _cache[6] || (_cache[6] = ($event: any) => (_ctx.loadData($event))),
                threshold: "100px",
                id: "infinite-scroll",
                disabled: _ctx.isDisabled
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_infinite_scroll_content, {
                    "loading-spinner": "bubbles",
                    "loading-text": "Carregando Produtos..."
                  })
                ]),
                _: 1
              }, 8, ["disabled"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_FooterMenu, { data: {inicial:false} })
    ]),
    _: 1
  }))
}